import { combineReducers } from '@reduxjs/toolkit';
import ListReducers from './list';
import FormReducers from './form';
import TeamsToExportReducers from './teamsToExport';

const teamsReducers = combineReducers({
  form: FormReducers,
  list: ListReducers,
  teamsToExport: TeamsToExportReducers
});

export default teamsReducers;

export type TeamsReducers = ReturnType<typeof teamsReducers>
